import { render, staticRenderFns } from "./AcquisitionFAQ.vue?vue&type=template&id=79e0b218&scoped=true&"
import script from "./AcquisitionFAQ.vue?vue&type=script&lang=ts&"
export * from "./AcquisitionFAQ.vue?vue&type=script&lang=ts&"
import style0 from "./AcquisitionFAQ.vue?vue&type=style&index=0&id=79e0b218&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e0b218",
  null
  
)

export default component.exports